"use strict";

(function () {
  if (!window.location.pathname.includes("/products/")) return;

  let items = JSON.parse(localStorage.getItem("recentlyViewedProducts")) || [];

  const handle = window.location.pathname
    .split("/products/")[1]
    ?.split("?")[0];

  if (!handle) return;

  items = items.filter(item => item.handle !== handle);

  items.push({
    handle: handle,
    timestamp: Date.now()
  });

  items = items.slice(-12);

  localStorage.setItem("recentlyViewedProducts", JSON.stringify(items));
})();